import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { normalizeOutgoingCallRecord, } from '../model/qstat-calls.model';
import { appendCriteriaContains, appendCriteriaEquals, appendCriteriaIn, readPagedRows, } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiBase = API_ROUTES.qstat.outgoingCalls;
const initialState = {
    loading: false,
    errorMessage: null,
    records: [],
    totalItems: 0,
};
function buildParams(params) {
    const q = new URLSearchParams();
    appendCriteriaEquals(q, 'startDate', params.startDate);
    appendCriteriaEquals(q, 'endDate', params.endDate);
    appendCriteriaIn(q, 'sipUser', params.agents);
    appendCriteriaIn(q, 'disposition', params.dispositions);
    appendCriteriaContains(q, 'dst', params.phoneNumber);
    appendCriteriaEquals(q, 'callType', params.callType);
    appendCriteriaEquals(q, 'trunkNames', params.trunkName);
    q.set('sort', params.sort ?? 'id,desc');
    return q;
}
export const getOutgoingCallsReport = createAsyncThunk('outgoingCalls/fetch_report', async (params) => {
    const q = buildParams(params);
    const qs = q.toString();
    const url = qs ? `${apiBase}?${qs}` : apiBase;
    const res = await axios.get(url);
    const { rows, total } = readPagedRows(res.data, res.headers);
    return { rows: rows.map(normalizeOutgoingCallRecord), total };
}, { serializeError: serializeAxiosError });
export const outgoingCallsSlice = createSlice({
    name: 'outgoingCalls',
    initialState: initialState,
    reducers: {
        clearOutgoingCallsReport(state) {
            state.records = [];
            state.totalItems = 0;
            state.errorMessage = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getOutgoingCallsReport.fulfilled, (state, action) => {
            state.loading = false;
            state.records = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addMatcher(isPending(getOutgoingCallsReport), (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
            .addMatcher(isRejected(getOutgoingCallsReport), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearOutgoingCallsReport } = outgoingCallsSlice.actions;
export default outgoingCallsSlice.reducer;
